// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
// ── Pack selector vocabulary (the ONLY selector src may use) ──
/**
 * The `event_type` that declares a placeholder kind.
 *
 * ONE selector for both kinds, deliberately. A per-kind selector would be a
 * platform constant that means "emergency order" or "post-quantum" — an
 * instrument's subject matter in `src/`, which is the R-46 violation this
 * capability is most exposed to. The kinds are `request_types[]` on the
 * declaring record and the platform never branches on their values.
 */
export const REGULATORY_PLACEHOLDER_EVENT_TYPE = 'regulatory_placeholder';
/**
 * Guidance-record `tags` the register selects the pack's own boundary
 * statements by, in the house `boundaryStatements(orgId, tag)` shape.
 */
export const REGULATORY_PLACEHOLDER_GUIDANCE_TAG = 'placeholder_boundary';
// ── The record ──
/**
 * Whether the organisation still considers this intake open.
 *
 * Two values, and neither is a legal state. `closed` means an operator has
 * finished with the note; it withdraws nothing, satisfies nothing and starts
 * no clock. A three-state lifecycle was declined for the same reason the
 * register exists: a status vocabulary that reads like a compliance workflow
 * would make the record look enforceable.
 */
export const REGULATORY_PLACEHOLDER_STATUSES = ['recorded', 'closed'];
export const REGULATORY_PLACEHOLDER_COLLECTION = 'grc_regulatory_placeholders';
// ── Errors ──
/**
 * One code per distinct condition — the one-code-per-condition rule the
 * classification module's own error block records the reason for.
 */
export const REGULATORY_PLACEHOLDER_ERROR_CODES = {
    /** No installed pack declares any placeholder kind. A `409`: install content. */
    NO_KIND_INSTALLED: 'regulatory_placeholder_no_kind_installed',
    /** The caller named a kind no installed record declares. A `400`. */
    KIND_NOT_DECLARED: 'regulatory_placeholder_kind_not_declared',
    /** No such record in this organisation. A `404`. */
    RECORD_NOT_FOUND: 'regulatory_placeholder_not_found',
};
//# sourceMappingURL=regulatory-placeholders.js.map